import api from './api';

export interface SiteSettings {
  site_name: string;
  site_email: string;
  site_phone: string;
  site_address: string;
  facebook_url: string;
  instagram_url: string;
  linkedin_url: string;
  about_text: string;
  registration_open: string;
  show_partners: string;
  maintenance_mode: string;
}

export const settingsService = {
  async get() {
    const { data } = await api.get<SiteSettings>('/settings');
    return data;
  },

  async update(payload: Partial<SiteSettings>) {
    const { data } = await api.put<SiteSettings>('/settings', payload);
    return data;
  },
};
